// Sets --fc-author-mx/my (-0.5..0.5) and --fc-author-sx/sy (0..100%) on
// [data-fc-author-page]; SCSS reads them for the parallax + spotlight.
export function initAuthorPage(doc: Document = document): void {
  const page = doc.querySelector<HTMLElement>('[data-fc-author-page]');
  if (!page) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let raf = 0;
  let mx = 0;
  let my = 0;
  let sx = 50;
  let sy = 50;

  page.addEventListener('pointermove', (event) => {
    const rect = page.getBoundingClientRect();
    const xRatio = (event.clientX - rect.left) / rect.width;
    const yRatio = (event.clientY - rect.top) / rect.height;
    mx = xRatio - 0.5;
    my = yRatio - 0.5;
    sx = xRatio * 100;
    sy = yRatio * 100;
    if (!raf) raf = requestAnimationFrame(apply);
  });

  function apply(): void {
    raf = 0;
    page.style.setProperty('--fc-author-mx', mx.toFixed(3));
    page.style.setProperty('--fc-author-my', my.toFixed(3));
    page.style.setProperty('--fc-author-sx', `${sx.toFixed(1)}%`);
    page.style.setProperty('--fc-author-sy', `${sy.toFixed(1)}%`);
  }
}
